import { acp } from '../constants.mjs';
import { getLinkedResourceUrlAll } from '../resource/resource.mjs';

//
/**
 * @param linkedAccessResource A Resource exposed via the Link header of another Resource with rel="acl".
 * @returns Whether that Resource is an ACP ACR or not (in which case it's likely a WAC ACL).
 */
function isAcr(linkedAccessResource) {
    const relTypeLinks = getLinkedResourceUrlAll(linkedAccessResource).type;
    return (Array.isArray(relTypeLinks) &&
        relTypeLinks.includes(acp.AccessControlResource));
}

export { isAcr };
